// import { Add, Close, Remove } from '@mui/icons-material'
// import { Box, Button, Dialog, DialogContent, IconButton, Stack, Typography, useTheme } from '@mui/material'
// import CustomTypography from 'components/Fileds/CustomTypography'
// import React, { useEffect, useState } from 'react'

// const UpdateQunatity = ({ open, onClose, item, onSave }) => {
//   const theme = useTheme();
//   console.log(item,"itemmaijeisfjeoijfo")
//   const [selections, setSelections] = useState([])

//   // initialize local state whenever the item changes
//    useEffect(() => {
//     if (item?.addOnSelections) {
//       // deep‐clone so we don’t mutate the prop
//       setSelections(item.addOnSelections.map(s => ({ ...s })))
//     }
//   }, [item])

//   const changeQty = (idx, delta) => {
//     setSelections(selections.map((sel, i) =>
//       i === idx
//         ? { ...sel, quantity: Math.max(0, sel.quantity + delta) }
//         : sel
//     ))
//   }

//   const handleSave = () => {
//     onSave(selections)
//     onClose()
//   }

//   if (!item) return null

//   return (
//     <Dialog className="update-qunantity-container" open={open} onClose={onClose} maxWidth="xs" fullWidth PaperProps={{ sx: { borderRadius: '20px', padding: '30px', color: 'black' } }}>
//       <DialogContent sx={{
//         p: 0, "&::-webkit-scrollbar": {
//           width: 0,
//           height: 0,
//         }, msOverflowStyle: "none", scrollbarWidth: "none",
//       }}
//       >
//         <Box className='close-icon-contianer'>
//           <IconButton onClick={onClose} className="close-icon">
//             <Close />
//           </IconButton>
//         </Box>

//           <Box className='d-flex' sx={{ pb: 0, flexDirection:'column' }}>
// <Box className='d-flex align-items-center'>
//   <CustomTypography
//     label={`Update`}
//     sx={{ fontSize: '24px', fontWeight: 400, color: theme.palette.typographyLabel.main }}
//   />

//   <CustomTypography
//     label={item.name}
//     sx={{ fontSize: '24px', fontWeight: 700, color: theme.palette.typographyLabel.main }}
//   />
// </Box>
//             <Box>
// <CustomTypography
//   label={`This item has been added with multiple add-ons.
//             Please select which one you would like to remove
//             or update quantity.`}
//   sx={{ fontSize: '16px', fontWeight: 400, color: theme.palette.drawermenuitem.main }}
// />
//             </Box>
//           </Box>
//            <Box sx={{ px: 2, py: 1, maxHeight: 300, overflowY: 'auto' }}>
//           {selections.map((sel, idx) => (
//             <Box key={sel.id} sx={{ mb: 2 }}>
//               {/* Display each group name & the chosen option(s) */}
//               {sel.groups.map(group => {
//                 // find the selected add-ons for this group
//                 const chosen = sel.addOns.filter(a =>
//                   group.add_ons.some(g => g.id === a.id)
//                 )
//                 return (
//                   <CustomTypography
//                     key={group.name}
//                     label={`${group.name}: ${chosen.map(c => c.name).join(', ') || '—'}`}
//                     sx={{ mb: 0.5, fontWeight: group.group_type === 'single' ? 600 : 400 }}
//                   />
//                 )
//               })}

//               {/* Quantity controls */}
//               <Stack direction="row" spacing={1} alignItems="center">
//                 <IconButton size="small" onClick={() => changeQty(idx, -1)}>
//                   <Remove fontSize="small" />
//                 </IconButton>
//                 <Typography width={24} textAlign="center">
//                   {sel.quantity}
//                 </Typography>
//                 <IconButton size="small" onClick={() => changeQty(idx, +1)}>
//                   <Add fontSize="small" />
//                 </IconButton>
//               </Stack>
//             </Box>
//           ))}
//         </Box>
//         <Box sx={{ px: 3, py: 2, textAlign: 'center' }}>
//           <Button
//             variant="contained"
//             size="large"
//             onClick={handleSave}
//             fullWidth
//           >
//             Save
//           </Button>
//         </Box>

//       </DialogContent>
//     </Dialog>
//   )
// }

// export default UpdateQunatity




import React, { useState, useEffect } from 'react';
import {
  Dialog,
  DialogContent,
  IconButton,
  Box,
  Typography,
  Stack,
  Button,
  useTheme
} from '@mui/material';
import { Close, Add, Remove } from '@mui/icons-material';
import "./style.css";
import CustomButton from 'components/Fileds/CustomButton';
import CustomTypography from 'components/Fileds/CustomTypography';

export default function UpdateQuantity({
  open,
  onClose,
  item,
  onSave,
  onAddNew,
  showAddNew
}) {
  const theme = useTheme();
  const [selections, setSelections] = useState([]);
  useEffect(() => {
    if (item?.addOnSelections) {
      setSelections(item.addOnSelections.map(s => ({ ...s })));
    }
  }, [item]);

  const changeQty = (idx, delta) => {
    setSelections(selections.map((sel, i) =>
      i === idx
        ? { ...sel, quantity: Math.max(0, sel.quantity + delta) }
        : sel
    ));
  };

  const handleSave = () => {
    onSave(selections);
    onClose();
  };

  if (!item) return null;

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="xs"
      fullWidth
      className='update-qunantity-container'
      PaperProps={{
        sx: {
          borderRadius: '20px',
          p: 0,
          overflow: 'hidden'
        }
      }}
    >
      <DialogContent sx={{ p: 0 }}>
        {/* HEADER */}
        <Box className='' sx={{ position: 'relative', textAlign: 'center', py: 2 }}>
          <IconButton
            onClick={onClose}
            size="small"
            sx={{ position: 'absolute', right: 8, top: 8 }}
          >
            <Close />
          </IconButton>
          <Box className='d-flex align-items-center justify-content-center' sx={{ mt: 2 }}>
            <CustomTypography
              label={`Update`}
              sx={{ fontSize: '24px', fontWeight: 400, color: theme.palette.typographyLabel.main, mr:0.5 }}
            />

            <CustomTypography
              label={item.name}
              sx={{ fontSize: '24px', fontWeight: 700, color: theme.palette.typographyLabel.main }}
            />
          </Box>
          <Box>
            <CustomTypography
              variant="body2"
              sx={{ mt: 1, px: 4, color: '#A1A1A1', fontWeight: 400, fontSize: "16px", mb:0 }}
              label={"This item has added with multiple add-ons. Please select which one you would like to remove or update quantity"}
            />
          </Box>
        </Box>

        {/* BODY: one row per selection */}
        <Box sx={{ px: 4, pt: 1, pb: 2, maxHeight: '300px', minHeight: '300px', overflowY: 'auto' }}>
          {selections.map((sel, i) => (
            <Box className='d-flex align-items-center justify-content-between items-container' key={sel.id}>
              {/* <Box className='item-contianer'>
                <Box className='d-flex align-items-center'>
                  <CustomTypography
                    variant={"subtitle2"}
                    label={`Size:`}
                    sx={{fontWeight:600,fontSize:'16px', mb:0 }}
                  />
                  <CustomTypography
                    label={sel.size}
                    variant={"subtitle2"}
                    sx={{fontWeight:400, fontSize:'16px', mb:0}}
                  />
                </Box>

                {sel.addOns && sel.addOns.length > 0 && (
                  <Box className='d-flex align-items-center justify-content-center'
                    sx={{flexDirection: sel?.groups[0]?.group_type == 'mulitple' ? 'column' : 'row'}}
                  >
                    <CustomTypography
                      label={"Add-ons:"}
                      variant={"subtitle2"}
                      sx={{fontWeight:600,fontSize:'16px', mb:0 }}
                    />
                    <CustomTypography
                      label={sel.addOns.map(a => a.name).join(', ')}
                      variant={"subtitle2"}
                      sx={{fontWeight:400, fontSize:'16px', mb:0}}
                    />
                  </Box>
                )}

                {sel.gravy && (
                  <Typography variant="body2" sx={{ mt: 0.5 }}>
                    Gravy: {sel.gravy}
                  </Typography>
                )}
              </Box> */}


              <Box>
                {sel.groups.map(group => {
                  // find the names of the selected addons for this group
                  const chosenNames = sel.addOns
                    .filter(a => group.add_ons.some(g => g.id === a.id))
                    .map(a => a.name);

                  if (group.group_type === 'single') {
                    // inline: “Size: Large”
                    return (
                      <Box
                        key={group.id}
                        className='d-flex align-items-center'
                      >
                        <CustomTypography
                          variant="subtitle2"
                          label={`${group.name}:`}
                          sx={{ fontWeight: 600, fontSize: '16px', mr: 0.5, mb: 0 }}
                        />
                        <CustomTypography
                          variant="subtitle2"
                          label={chosenNames[0] || '—'}
                          sx={{ fontWeight: 400, fontSize: '16px', mb: 0 }}
                        />
                      </Box>
                    );
                  } else {
                    return (
                      <Box
                        key={group.id}
                        sx={{ display: 'flex', flexDirection: 'column' }}
                      >
                        <CustomTypography
                          variant="subtitle2"
                          label={`${group.name}:`}
                          sx={{ fontWeight: 600, fontSize: '16px', mb: 0 }}
                        />
                        <CustomTypography
                          variant="subtitle2"
                          label={chosenNames.join(', ') || 'No Add-ons'}
                          sx={{ fontWeight: 400, fontSize: '16px', mb: 0 }}
                        />
                      </Box>
                    );
                  }
                })}
              </Box>

              <Box className='quantity-cart-item-container'
                sx={{ border: `1px solid ${theme.palette.primary.main}` }}
              >
                <Button
                  sx={{ color: theme.palette.primary.main }}
                  className='quantity-cart-item'
                  onClick={() => changeQty(i, -1)}
                >
                  <Remove fontSize="16px" />
                </Button>
                <Typography sx={{ mx: 1 }}>{sel.quantity}</Typography>
                <Button
                  className='quantity-cart-item'
                  sx={{ color: theme.palette.primary.main }}
                  onClick={() => changeQty(i, +1)}
                >
                  <Add fontSize="16px" />
                </Button>
              </Box>
            </Box>
          ))}
        </Box>

        {/* FOOTER */}
        <Box className='d-flex align-items-center justify-content-center' sx={{ px: 3, pb: 3, gap: 2 }}>
          {/* {isAddVisible &&  */}
         {showAddNew && <CustomButton
            fullWidth
            sx={{
              border: `1px solid ${theme.palette.primary.main}`,
              color: theme.palette.primary.main,
              background: 'transparent',
              borderRadius: '10px',
              width: "160px"
            }}
            onClick={onAddNew}
          >
            Add New
          </CustomButton>}
           {/* } */}
          <CustomButton
            fullWidth
            onClick={handleSave}
            sx={{ width: '150px', borderRadius: '10px' }}
          >
            Save
          </CustomButton>
          {/* <Button
            variant="contained"
            fullWidth
            onClick={handleSave}
            sx={{
              backgroundColor: theme.palette.text.primary,
              color: theme.palette.common.white,
              borderRadius: 2,
              py: 1.25,
              textTransform: 'none',
              fontSize: '1rem',
              '&:hover': {
                backgroundColor: theme.palette.text.dark
              }
            }}
          >
            Save
          </Button> */}
        </Box>
      </DialogContent>
    </Dialog>
  );
}
